<template>
  <div class>
    <!-- <transition name="fade" mode="out-in"> -->
    <nav
      v-show="event"
      class="navbar is-fixed-top has-border-bottom"
      :class="{'hidden-top-navbar': !$store.state.ui.showCitySelect}"
      role="section"
    >
      <div class="container">
        <div class="navbar-brand">
          <BackButton></BackButton>

          <div
            class="ml-half"
            key="title"
            @click="scrollToTop"
            style="height: 48px; max-width: 50vw; "
          >
            <span
              v-if="true"
              style="padding-top: 12px;  line-height: 1"
              class="is-block is-size-15px has-text-black-ter has-ellipsis has-text-weight-semibold"
            >{{ eventPreview ? eventPreview.data.eventName : event ? event.data.eventName : '' }}</span>

            <span
              v-if="true"
              class="is-block is-size-7 has-text-weight-medium has-text-grey"
            >{{ eventPreview ? $t(`evType.${eventPreview.data.eventMainType}`) : event ? $t(`evType.${event.data.eventMainType}`) : '' | capitalize }}</span>
          </div>

          <!-- <transition name="fade" mode="out-in"> -->
          <div
            class="navbar-item ml-auto"
            key="buy"
            style="padding-bottom: 9px; padding-right: 10px;"
            v-if="$store.state.ui.showCitySelect && event"
          >
            <div class="buy-wrapper">
              <div v-if="!event.data.eventTicketInfo.isAffiliate" class="is-flex">
                <button @click="hitBuyButton" class="button is-on-navbar is-rounded is-danger">
                  <span>{{ $t('ui.buyTicket') }}</span>
                </button>
              </div>

              <div class="is-flex" v-else>
                <a
                  @click="openRedirectModal('top_navigation_bar')"
                  class="button is-on-navbar is-rounded is-danger"
                >
                  <span>{{ $t('ui.buyTicket') }}</span>
                </a>
              </div>
            </div>
          </div>

          <div class="navbar-item ml-auto" key="share" v-else>
            <b-dropdown aria-role="list">
              <span class="is-size-6 has-text-link has-text-weight-normal is-small" slot="trigger">
                <!-- <span class="icon is-small">
                    <i class="mdi mdi-share mdi-24px"></i>
                </span>-->
                {{ $t('ui.share') | capitalize }}
              </span>

              <b-dropdown-item
                aria-role="listitem"
                class="has-text-black-bis has-text-weight-semibold is-size-18px"
              >{{ $t('ui.share') | capitalize}}</b-dropdown-item>
              <!-- <b-dropdown-item aria-role="listitem" separator></b-dropdown-item> -->
              <a
                style="padding: 0.75rem 1.5rem"
                class="is-fullwidth is-block has-text-grey-darker"
                aria-role="listitem"
                :href="`whatsapp://send?text=https://hafta8.com${$route.fullPath}`"
                data-action="share/whatsapp/share"
              >
                <span class="icon is-small" style="margin-right: 8px; padding-left:4px">
                  <i class="mdi mdi-whatsapp mdi-16px"></i>
                </span>&nbsp;
                WhatsApp
              </a>
              <a
                aria-role="listitem"
                class="is-fullwidth is-block has-text-grey-darker"
                style="padding: 0.75rem 1.5rem"
                :href="`http://www.facebook.com/sharer.php?u=https://hafta8.com${$route.fullPath}`"
                target="_blank"
              >
                <span class="icon is-small" style="margin-right: 8px; padding-left:4px">
                  <i class="mdi mdi-facebook mdi-16px"></i>
                </span>&nbsp;
                Facebook
              </a>
              <!-- <b-dropdown-item aria-role="listitem">
                <span class="icon is-small" style="margin-right: 8px; padding-left:4px">
                  <i class="mdi mdi-instagram mdi-16px"></i>
                </span>&nbsp;
                <a
                  :href="`http://www.facebook.com/sharer.php?u=${$route.fullPath}`"
                  target="_blank"
                ></a>
                Instagram
              </b-dropdown-item>-->
              <!-- <b-dropdown-item aria-role="listitem">
              <span class="icon is-small" style="margin-right: 8px; padding-left:4px"><i class="mdi mdi-facebook-messenger mdi-16px"></i></span>&nbsp;
              Messenger</b-dropdown-item>-->
            </b-dropdown>
            <!-- <b-tooltip label="You prefer dark?" type="is-dark" position="is-bottom">
              <span class="icon is-normal">
                <i class="mdi mdi-share mdi-24px"></i>
              </span>
            </b-tooltip>-->
          </div>
          <!-- </transition> -->
        </div>
      </div>
    </nav>

    <!-- </transition> -->
    <!-- Event view -->
    <!-- v-if="!$store.state.ui.isLoading && event" -->
    <div class="event-view" :key="event ? event.id : ''">
      <div
        v-if="event && event.data.eventStatus !== 'active'"
        class="is-fullwidth has-background-danger py-half has-text-white has-text-centered is-size-18px has-text-weight-semibold"
      >{{$t('ui.thisEventIsPassed')}}</div>

      <section>
        <div class="container" itemscope itemtype="http://schema.org/Event">
          <!-- HEADER -->

          <div class="media section-padding" style="padding-top: 12px" v-if="event || eventPreview">
            <figure
              class="media-left"
              style="margin-right: 0.75rem;"
              @click="isImageModalActive = true"
            >
              <p class="image is-poster" :style="`border-radius: 2px`">
                <!-- :src="event.data.eventImagePaths.posterURLs[1]" -->
                <img
                  itemprop="image"
                  v-if="event.data.eventImagePaths.posterURLs"
                  :alt="event.data.eventName"
                  class="is-lazy"
                  lazy="loaded"
                  v-lazy="event.data.eventImagePaths.posterURLs[0]"
                />
              </p>
            </figure>
            <div class="media-content event-header">
              <div style="transform: translateY(-6px);">
                <!-- EVENT TYPEs -->
                <div class="has-ellipsis is-size-15px" style="max-width: 54vw; line-height: 1.35">
                  <router-link
                    :to="{name: 'events', params: {cityName: $store.state.user.userCity, slug: event.data.eventMainType }}"
                    class="cursor-link has-text-link"
                  >{{ $t(`evType.${event.data.eventMainType}`) | capitalize }}</router-link>
                  <span
                    v-if="event.data.eventSubTypes.length"
                    class="icon is-small has-text-grey"
                    style="transform: translateY(1.9px);"
                  >
                    <i class="mdi mdi-chevron-right mdi-16px"></i>
                  </span>
                  <router-link
                    v-for="(subtype,ind) in event.data.eventSubTypes"
                    :key="subtype.id"
                    :to="{ name: 'events', params: {cityName: $store.state.user.userCity,slug: event.data.eventMainType }, query: { subtype }}"
                    class="cursor-link has-text-link"
                  >{{ $t(`evType.${subtype}`) | capitalize }}<span v-if="ind <= event.data.eventSubTypes.length && ind !== event.data.eventSubTypes.length-1">,&nbsp;</span> </router-link>
                </div>
                <!-- EVENT NAME -->
                <h1
                  itemprop="name"
                  class="title  is-size-5 has-text-weight-semibold"
                  style="line-height: 1.35; margin-top: 2px;margin-bottom: 4px"
                >{{ event.data.eventName }}</h1>
                <!-- <p class="is-size-7 has-text-info mb-half" v-if="event.data.eventVenueURL">@{{ event.data.eventVenueURL }}</p> -->
              </div>

              <!-- <div>
                <div class="buttons">
                  <b-button size="is-small" icon-left="star">{{ $t('ui.interested') }}</b-button>
                  <b-button size="is-small" icon-left="check">{{ $t('ui.going') }}</b-button>
                </div>
              </div> -->

              <!-- BUY BUTTON -->
              <div
                v-if="true"
                class="buy-wrapper"
                itemprop="offers"
                itemscope
                itemtype="http://schema.org/Offer"
              >
                <meta
                  itemprop="validFrom"
                  :content="$options.filters.toHTMLDateTime(new Date(event.data.eventShowtimes[0].startTime))"
                />
                <meta itemprop="priceCurrency" content="TRY" />
                <link itemprop="url" :href="`https://hafta8.com/event/${event.id}`" />
                <link itemprop="availability" href="http://schema.org/InStock" />

                <!-- Affiliate -->
                <div class="is-flex" v-if="event.data.eventTicketInfo.isAffiliate">
                  <a
                    @click="openRedirectModal('on_page')"
                    class="button is-on-navbar is-rounded is-danger"
                  >
                    <meta
                      itemprop="price"
                      :content="calcMainTicketPrice(event.data.eventTicketInfo)"
                    />
                    <span>{{ $t('ui.buyTicket') }}</span>
                  </a>
                  <div class="buy-extra-info" style="transform: translateY(2px)">
                    <span class="ml-half has-text-grey-dark">
                      {{ $t('ui.ticketProvider') }}:
                      <span
                        class="ml-0"
                      >{{ event.data.eventTicketInfo.affiliateInfo.affiliateProviderName }}</span>
                    </span>
                  </div>
                </div>

                <div v-else-if="event.data.eventTicketInfo.isSoldOnDoor" class="is-flex">
                  <button
                    itemprop="price"
                    :content="calcMainTicketPrice(event.data.eventTicketInfo)"
                    class="button is-on-navbar is-rounded is-danger"
                  >{{ $t('ui.buyTicket') }}</button>
                  <div class="buy-extra-info" style="transform: translateY(2px)">
                    <span class="ml-half has-text-grey">{{ $t('ui.ticketsAreSoldOnDoor') }}</span>
                  </div>
                </div>

                 <div v-else-if="event.data.eventTicketInfo.isFree" class="is-flex">
                  <button
                    class="button is-on-navbar is-outlined has-text-weight-medium is-rounded is-danger"
                  >{{ $t('ui.free') }}</button>
                </div>

                <div v-else-if="!event.data.eventTicketInfo.isAffiliate" class="is-flex">
                  <button
                    @click="hitBuyButton"
                    itemprop="price"
                    :content="calcMainTicketPrice(event.data.eventTicketInfo)"
                    class="button is-on-navbar has-text-weight-medium is-rounded is-danger"
                  >{{ $t('ui.buyTicket') }}</button>
                </div>
              </div>
            </div>
          </div>

          <EventTickets
            style="margin-bottom: 12px; margin-top: 0px"
            v-if="event && !event.data.eventTicketInfo.isFree"
            :event="event"
            :title="$t('ui.date')"
          ></EventTickets>

          <EventDates
            style="margin-bottom: 12px; margin-top: 0px"
            v-if="event"
            :event="event"
            :title="$t('ui.date')"
          ></EventDates>

          <EventLocation v-if="event" class="mt-half" :event="event"></EventLocation>

          <div
            v-if="isLoading"
            style="min-height: 100px; width: 100%; overflow:hidden; position: relative"
          >
            <b-loading animation :is-full-page="false" :active.sync="isLoading" :can-cancel="false"></b-loading>
          </div>

          <transition name="fade">
            <div v-if="!isLoading && event && event.details">
              <EventSummary :event-summary="event.details.eventSummary"></EventSummary>

              <EventRules v-if="event.details.eventRules" :event-rules="event.details.eventRules"></EventRules>

              <div class="mx-1 py-0">
                <hr />
              </div>

              <h3 class="mt-0 section-margin is-section-headline">{{ $t('ui.eventVenue')}}</h3>
              <div class="media section-padding pt-0 mb-half">
                <router-link
                  tag="div"
                  class="level is-mobile cursor-pointer"
                  style="width: 100%;"
                  :to="event.data.eventVenueID ? { name: 'venue-view' , params: { venueID: event.data.eventVenueID }} : ''"
                >
                  <div class="level-left">
                    <div class="level-item" style="max-width: 48px;">
                      <figure class>
                        <p class="image is-48x48 has-escape is-rounded">
                          <img
                            v-if="event.data.eventVenueAvatarURL"
                            class="is-rounded has-border"
                            :src="event.data.eventVenueAvatarURL"
                          />
                        </p>
                      </figure>
                    </div>

                    <div class="level-item content-justified-start">
                      <div>
                        <!-- <span
              class="is-block has-text-weight-light is-size-6-half"
              v-if="filteredEventsByVenueID.length"
                        >{{ $t('ui.moreFrom') }}</span>-->
                        <div
                          class="has-text-weight-normal is-size-15px has-text-link"
                        >{{ $options.filters.truncate(event.data.eventVenueName, 24)}}</div>
                        <div
                          class="has-text-weight-normal is-size-14px has-text-grey"
                        >@{{ event.data.eventVenueURL }}</div>

                        <!-- TODO: uncomment below two lines when follow is possible -->
                        <!-- <span>{{ event.data.eventOrganizerURL }}</span> -->
                      </div>
                    </div>
                  </div>

                  <div class="level-right">
                    <div class="level-item">
                      <span class="icon has-text-grey">
                        <i class="mdi mdi-chevron-right mdi-36px"></i>
                      </span>
                    </div>
                  </div>
                </router-link>
              </div>
              <div class="has-background-white-bis pt-half pb-half">
                <!-- OTHER EVENTS OF SAME VENUE -->
                <div v-show="eventCount && $route.name === 'event-view'" class="mt-half mb-half">
                  <TypeCard
                    key="eventsBySameVenue"
                    :route-name="$route.name"
                    @event-count="setEventCount"
                    :venue-id="event.data.eventVenueID"
                    :title-sm="true"
                    :show-type="false"
                    :is-single-col="true"
                    :order-limit="4"
                    :event-limit="3"
                    :section-header-title="$t('ui.eventsBySameVenue', {msg: event.data.eventVenueName})"
                    :event-id="event.id"
                    :event-type="''"
                    :title-has-border-top="false"
                  ></TypeCard>
                </div>
              </div>

              <!-- REALTED EVENTS -->
              <div class="has-background-white-bis pt-half">
                <!-- :see-all-path="`/events/${event.data.eventMainType}`" -->
                <TypeCard
                  key="typeYouMightBeInterested"
                  :route-name="$route.name"
                  :event-id="event.id"
                  :event-type="event.data.eventMainType"
                  :show-sub-type="true"
                  :event-subtypes="event.data.eventSubTypes"
                  :title-sm="true"
                  :is-single-col="true"
                  :event-limit="4"
                  :order-limit="4"
                  :section-header-title="`${$t('ui.typeYouMightBeInterested', { msg: this.$i18n.locale === 'tr' ? $options.filters.toLowerCaseTurkish($t('evType.'+ event.data.eventMainType)) : $t('evType.'+ event.data.eventMainType) })}`"
                  :title-has-border-top="false"
                ></TypeCard>

                <div class="mx-1 my-1" style>
                  <router-link
                    class="button is-primary is-outlined is-fullwidth"
                    :to="{name: 'events', params: {cityName: $store.state.user.userCity, slug: event.data.eventMainType }}"
                  >{{ $t('ui.seeAllEventsOfType', { msg: this.$options.filters.toLowerCaseTurkish($t(`evType.${event.data.eventMainType}`))}) }}</router-link>
                </div>
              </div>
              <!-- END: REALTED EVENTS -->
            </div>
          </transition>
          <!-- SIMILAR VENUS -->
          <!-- <CardRailVenue :venue-type="event.data"></CardRailVenue> -->
        </div>
      </section>
    </div>

    <!-- IMAGE MODAL -->
    <b-modal :active.sync="isImageModalActive" v-if="event">
      <p class="image">
        <img
          v-lazy="event.data.eventImagePaths.posterURLs[2]"
          :alt="event.data.eventName"
          class="is-lazy"
          lazy="loaded"
        />
      </p>
    </b-modal>
    <!-- IMAGE MODAL -->

    <!-- REDIRECT MODAL -->
    <b-modal
      :can-cancel="['escape', 'outside']"
      :active.sync="isRedirectModalActive"
      has-modal-card
      trap-focus
      v-if="event"
    >
      <div class="modal-card mx-1" style="width: auto; border-radius: 8px">
        <section class="modal-card-body has-text-centered">
          <p>{{ $t('ui.willBeRedirect', { msg: event.data.eventTicketInfo.affiliateInfo.affiliateProviderName}) }}</p>
        </section>
        <section class="modal-card-foot has-background-white">
          <button
            class="has-text-info button is-white"
            @click="isRedirectModalActive=false"
          >{{ $t('ui.cancel') }}</button>
          <a
            :href="event.data.eventTicketInfo.affiliateInfo.affiliateBuyLink"
            target="_blank"
            class="button ml-auto has-text-info button is-white"
            @click="goToTicket"
          >{{ $t('ui.goToTicket') }}</a>
        </section>
      </div>
    </b-modal>
    <!-- END: REDIRECT MODAL -->
  </div>
</template>

<script>
import BackButton from "@/components/ui/BackButton";
import { ticketPriceMixin } from "@/mixins/ticket";
import { mapGetters } from "vuex";

export default {
  name: "event-view",
  mixins: [ticketPriceMixin],
  components: {
    EventSummary: () => import("@/components/event/EventSummary"),
    EventDates: () => import("@/components/event/EventDates"),
    EventTickets: () => import("@/components/event/EventTickets"),
    EventLocation: () => import("@/components/event/EventLocation"),
    EventRules: () => import("@/components/event/EventRules"),
    TypeCard: () => import("@/components/sections/TypeCard"),
    BackButton
  },
  metaInfo() {
    if (!this.event || this.event.id !== this.$route.params.eventID) return {};

    if (!this.event.details) return {};

    const type = this.$t(
      `evType.${this.event.data.eventMainType}`
    ).toLocaleLowerCase();

    let VALID_FROM = new Date(this.event.data.eventShowtimes[0].startTime);
    VALID_FROM.setDate(VALID_FROM.getDate() - 10);
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.event.data.eventName,
      // all titles will be injected into this template
      titleTemplate: `%s • ${this.event.data.eventShowtimes[0].startTime.getDate()} ${this.$t(
        `monthNames.${this.event.data.eventShowtimes[0].startTime.getMonth()}`
      )} - ${this.event.data.eventVenueName} • ${this.$t(
        "ui.buyTicket"
      )} | hafta8.com`,
      meta: [
        {
          name: "description",
          content: this.event.details.eventSummary.slice(0, 160)
        },
        {
          name: "keywords",
          content: this.event.details.eventSummary.slice(0, 160)
        },

        { name: "twitter:card", content: "summary" },
        {
          name: "twitter:title",
          content: this.event.data.eventName + " - " + type + " | hafta8.com"
        },
        {
          name: "twitter:description",
          content: this.event.details.eventSummary.slice(0, 160)
        },
        {
          name: "twitter:image",
          content: this.event.data.eventImagePaths.posterURLs[0]
        },

        { vmid: "og:type", property: "og:type", content: "article" },
        {
          property: "og:title",
          content: this.event.data.eventName + " • " + type + " | hafta8.com"
        },
        {
          property: "og:description",
          content: this.event.details.eventSummary.slice(0, 160)
        },
        {
          property: "og:image",
          content: this.event.data.eventImagePaths.posterURLs[0]
        },
        {
          property: "og:url",
          content: "https://hafta8.com" + this.$route.fullPath
        }
      ],
      link: [
        {
          rel: "canonical",
          href: "https://hafta8.com" + this.$route.fullPath
        }
      ],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "Event",
            // url: "https://hafta8.com" + this.$route.fullPath,
            name:
              this.event.data.eventName + " " + this.event.data.eventMainType,
            startDate: this.$options.filters.toHTMLDateTime(
              this.event.data.eventShowtimes[0].startTime
            ),
            endDate: this.$options.filters.toHTMLDateTime(
              this.event.data.eventShowtimes[0].endTime
            ),
            performer: {
              "@type": "Person",
              name: this.event.data.eventName
            },
            location: {
              "@type": "Place",
              name: this.event.data.eventVenueName,
              address: {
                "@type": "PostalAddress",
                streetAddress: this.event.data.eventVenueRichAddress
                  .streetAddress,
                addressLocality: this.event.data.eventVenueRichAddress
                  .addressLocality,
                addressRegion: this.event.data.eventVenueRichAddress
                  .addressRegion,
                postalCode: this.event.data.eventVenueRichAddress.postalCode,
                addressCountry: this.event.data.eventVenueRichAddress
                  .addressCountry
              }
            },
            description: this.event.details.eventSummary,
            image: this.event.data.eventImagePaths.posterURLs[0],
            offers: {
              "@type": "Offer",
              validFrom: this.$options.filters.toHTMLDateTime(VALID_FROM),
              availability: "https://schema.org/InStock",
              price: this.calcMainTicketPrice(this.event.data.eventTicketInfo), // TODO remove tl from result
              priceCurrency: "TRY",
              url: "https://hafta8.com" + this.$route.fullPath
            }
          }
        }
      ]
    };
  },
  data() {
    return {
      eventPreview: null,
      event: null,
      isImageModalActive: false,
      isTicketSelectorOpen: false,
      eventsByVenueID: [],
      isRedirectModalActive: false,
      eventsOfSameSubType: [],
      eventCount: false,
      isLoading: false
    };
  },
  watch: {
    user(val) {
      if (val) {
        this.fetchEvent();
      }
    }
  },
  computed: {
    ...mapGetters({
      user: "user/userDoc"
    })
  },
  created() {
    // get route props
    this.eventPreview = this.$route.params.eventPreview || null;
    console.log("PREVIEW: ", this.eventPreview);
    this.event = this.$route.params.eventPreview || null;

    if (this.user) this.fetchEvent();
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    async fetchEvent() {
      // this.$store.commit("ui/SET_LOADING", true);
      this.isLoading = true;

      try {
        this.event = await this.$store.dispatch("appData/fetchEventByID", {
          id: this.$route.params.eventID
        });
      } catch (error) {
        if (process.env.NODE_ENV === "development") {
          console.error(error);
        }
      }
      this.isLoading = false;
      // this.$store.commit("ui/SET_LOADING", false);
    },
    eventSubtypesJoined(subtypes) {
      let joined = "";
      for (let i = 0; i < subtypes.length; i++) {
        joined += this.$options.filters.capitalize(
          this.$t(`evType.${subtypes[i]}`)
        );
        if (i !== subtypes.length - 1) joined += ", ";
      }
      return joined;
    },
    setEventCount(val) {
      console.log("set event count", val);
      this.eventCount = val;
    },
    async hitBuyButton() {
      if (this.event.data.eventTicketInfo.isFree) return;
      if (this.event.data.eventTicketInfo.hasSeatPlan)
        this.$store.dispatch("ui/toggleModal", {
          name: "BUY_MODAL_SEAT",
          state: true
        });
      else {
        await this.$store.commit("user/SET_DISPLAYED_EVENT", this.event);
        this.$router.push({
          name: "event-view-buy-modal",
          params: { eventID: this.event.id }
        });
      }
    },
    openRedirectModal(buttonPosition) {
      this.isRedirectModalActive = true;

      this.$analytics.logEvent("hit_buy_button", {
        item_id: this.event.id,
        item_name: this.event.data.eventName,
        item_venue: this.event.data.eventVenueName,
        button_position: buttonPosition
      });
    },
    goToTicket() {
      if (process.env.NODE_ENV === "development") {
        console.log("go to affiliate");
      }

      this.$analytics.logEvent("hit_buy_button_redirect", {
        item_id: this.event.id,
        item_name: this.event.data.eventName,
        item_venue: this.event.data.eventVenueName
      });

      this.isRedirectModalActive = false;
      //   window.location.href =
      //     this.event.data.eventTicketInfo.affiliateInfo.affiliateBuyLink
    }
  }
};
</script>

<style lang="scss" scoped>
.navbar .title-has-ellipsis {
  max-width: 46vw;
  padding-right: 0;
}
.buy-extra-info {
  display: flex;
  height: 31.5px;
  // padding-top: 1px;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
}

.buy-extra-info span {
  margin: auto 0 auto 0.5rem;
  max-width: 78px;
  // display: inline-block
  width: 100%;
  font-size: 10px;
  line-height: 1.2;
}

.modal-card-foot {
  border-top: 0;
  padding-top: 0;
}

.ticket-selector-section {
  width: 100%;
  height: 0;
  overflow: hidden;
}

.ticket-selector-section.is-open {
  height: 100%;
  min-height: 200px;
  overflow: auto;
}

$poster-width: 30vw;
$poster-min-height: $poster-width * 1.4;

.is-poster-wrapper {
  width: 100%;
  height: 100%;
  // min-height: $poster-min-height;
  margin: 0 auto;
  //   margin-top: 20px;
  position: relative;
  padding-top: 12px;
  // padding-bottom: 16px;
}

$card-width-lg-device: 200px;

$breakpoint-lg: 1000px;

p.image.is-poster {
  width: $poster-width;
  min-height: $poster-width;
  // border-radius: 6px;
  overflow: hidden;
  img {
    min-height: $poster-width;
  }
  @media screen and (min-width: $breakpoint-lg) {
    width: $card-width-lg-device;
    height: $card-width-lg-device * 1.4;
    min-height: $card-width-lg-device * 1.4;
    max-height: $card-width-lg-device * 1.4 !important;
  }
  // min-height: $poster-width * 1.481;
  -webkit-box-shadow: rgba(0, 0, 0, 0.3) 0 1px 3px;
  -moz-box-shadow: rgba(0, 0, 0, 0.3) 0 1px 3px;
  box-shadow: rgba(0, 0, 0, 0.3) 0 1px 3px;
}

.media {
  height: 100% !important;
  align-items: stretch;
  padding: 1.25rem;
  padding-bottom: 1rem;
}
.media-content {
  padding-top: 4px;
}
.media-content.event-header {
  display: flex;
  flex-direction: column;
}

.title {
  line-height: 1.25;
}

.buy-wrapper {
  margin-top: auto;
  justify-self: flex-end;
  // align-self: flex-end;
}

ul > li {
  list-style-type: disc;
}

.level {
  width: 100%;
}
</style>